import { type ReactNode, useEffect } from 'react';
import { Button } from './Button';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  children: ReactNode;
  confirmLabel?: string;
  danger?: boolean;
}

export function ConfirmModal({ open, onClose, onConfirm, title, children, confirmLabel = 'Confirm', danger = false }: ConfirmModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-void/70 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md bg-panel-bg border border-panel-border rounded-[3px]">
        <div className="px-4 py-3 border-b border-panel-border">
          <span className="text-xs font-mono font-semibold text-text-muted tracking-[1.4px] uppercase">{title}</span>
        </div>
        <div className="p-4 text-sm font-body text-text leading-relaxed">
          {children}
        </div>
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-panel-border">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </div>
    </>
  );
}
